const patternConstant = {
  ALPHANUMERIC: /^[a-zA-Z0-9- ]+$/,
  NUMERIC: /^[0-9]+$/,
  FLOATNUMERIC: /^\d+(\.\d{0,2})?$/,
  PERCENTAGE: /^(\d{0,2})(\.\d{0,2})?$/,
  ///^\d{0,2}+(\.\d{0,2})?$/
};

export const taskAllFields = [
  {
    id: "type",
    label: "Type",
    placeHolder: "Select type",
    type: "select",
    md: 6,
    isRequired: true,
    options: ["Task General"],
  },
  {
    id: "title",
    label: "Title",
    placeHolder: "Please enter title",
    type: "text",
    md: 6,
    inputProps: {
      maxLength: 50,
    },
    isRequired: true,
  },
  {
    id: "location",
    label: "Location",
    placeHolder: "Please enter location",
    type: "text",
    md: 6,
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
    isRequired: true,
  },
  {
    id: "status",
    label: "Status",
    placeHolder: "Select",
    type: "select",
    md: 6,
    isRequired: false,
    options: ["Pending", "In Progress", "Completed", "Cancelled"],
  },
  
  {
    id: "date",
    label: "Date",
    placeHolder: "Select",
    type: "date",
    md: 6,
    isRequired: true,
    // disablePast: true,
  },
    {
    id: "assigned_to",
    label: "Assigned To",
    placeHolder: "Select assigned person",
    type: "select",
    md: 6,
    options: [], // Will be populated dynamically with users
    isRequired: false,
    isDisabled: true,
  },
  {
    id: "start_time",
    label: "Start Time",
    placeHolder: "Select",
    type: "time",
    md: 6,
    isRequired: true,
    disablePast: true,
  },

  // {
  //   id: "endDate",
  //   label: "End Date",
  //   placeHolder: "Enter phone number",
  //   type: "date",
  // },
  {
    id: "end_time",
    label: "End Time",
    placeHolder: "Select",
    type: "time",
    md: 6,
    isRequired: true,
    disablePast: true,
  },

  {
    id: "notified_emails",
    label: "Email",
    placeHolder: "Enter email addresses (separate multiple with semicolon)",
    type: "emailChip",
    md: 12,
    inputProps: {
      maxLength: 500,
    },
    isRequired: false,
  },
  {
    id: "description",
    label: "Description",
    placeHolder: "Enter task description",
    type: "textarea",
    md: 12,
    inputProps: {
      maxLength: 500,
      rows: 3,
    },
    isRequired: false,
  },
];
